import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  gkShortsData: [],
  totalGkShorts: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
  isImageOpenModal: false,
}

export const gkShortsSlice = createSlice({
  name: "gkShorts",
  initialState,
  reducers: {
    setGkShortsData(state, { payload }) {
      state.gkShortsData = payload.result
      state.totalGkShorts = payload.count
    },
    updateGkShortsData(state, { payload }) {
      const objIndex = state.gkShortsData.findIndex((obj) => obj._id === payload.id);
      if (objIndex >= 0) {
        state.gkShortsData[objIndex].status = payload.status
      }
    },
    deleteGkShortsData(state, { payload }) {
      const objIndex = state.gkShortsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.gkShortsData.splice(objIndex, 1)
        state.totalGkShorts -= 1
      }
    },
    pushGkShortsData(state, { payload }) {
      state.gkShortsData.push(payload)
      state.totalGkShorts += 1
    },
    editGkShortsData(state, { payload }) {
      const objIndex = state.gkShortsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.gkShortsData[objIndex] = payload
      }
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setGkShortsData, updateGkShortsData, deleteGkShortsData, pushGkShortsData, editGkShortsData, isOpenModal, ModalToggle } = gkShortsSlice.actions;

export default gkShortsSlice.reducer;

export function getGkShorts(limit, offset,) {
  return async function getGkShortsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getGkShorts(limit, offset).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setGkShortsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addGkShorts(title, categoryId, videoUrl, description) {
  return async function addGkShortsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addGkShorts({ title, categoryId, videoUrl, description }).then(
        async (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushGkShortsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {
      dispatch(setLoading(false))
    }
  }
}
export function statusDeleteGkShorts(id) {
  return async function statuseleteGkShortsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteGkShorts(id).then(
        (response) => {
          dispatch(deleteGkShortsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function editGkShorts(id, data) {
  return async function editGkShortsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateGkShorts(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(editGkShortsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {
      dispatch(setLoading(false))
    }
  }
}